<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Iniciar Sesión</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form class="ma-4">
              <v-text-field
                v-model="email"
                label="Login"
                name="email"
                prepend-icon="person"
                type="text"
                placeholder="Email"
                autocomplete="off"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                type="password"
                placeholder="Contraseña"
                autocomplete="off"
              ></v-text-field>
              <div class="d-flex justify-end">
                <div class="mt-2 ml-1">
                  No tienes una cuenta?
                  <router-link to="register">Registrate ahora</router-link>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="text-capitalize"
                  @click.prevent="login"
                  >Login</v-btn
                >
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    login() {
      const { email, password } = this;
      this.$store.dispatch("doLogin", { email, password }).then(() => {
        this.$router.push("/news");
      });
    },
  },
};
</script>